import { r4Client, r4Error } from '@/services'
import useLogger from '@/composables/useLogger'
const logger = useLogger('DmsDatasourceApi')

const DmsDatasourceApi = {
  /**
   * DMS Datsource Templates
   */

  async fetchDmsDatasourceTemplates (queryParams) {
    try {
      const resp = await r4Client().get('/api/v1/dms_datasource_templates', { params: queryParams })
      return resp.data
    } catch (error) {
      throw new Error(r4Error(error))
    }
  },

  async getDmsDatasourceTemplate (templateId) {
    try {
      const resp = await r4Client().get('/api/v1/dms_datasource_templates/' + templateId)
      return resp.data
    } catch (error) {
      throw new Error(r4Error(error))
    }
  },

  async saveDmsDatasourceTemplate (templateData) {
    try {
      const saveOp = function () {
        if (templateData.id) {
          logger.trace(`API Updating dms template ${templateData.id}`)
          return r4Client().put(`/api/v1/dms_datasource_templates/${templateData.id}`, templateData)
        } else {
          logger.trace('Creating Dms Datasource')
          return r4Client().post('/api/v1/dms_datasource_templates', templateData)
        }
      }
      const resp = await saveOp()
      return resp.data
    } catch (error) {
      throw new Error(r4Error(error))
    }
  }
}

export default DmsDatasourceApi
